import React from 'react'
import PageTitleAndSnackBar from '../../components/common/PageTitleAndSnackBar'
import { useParams } from 'react-router-dom'
import AddFlight from '../../components/flight-detail/AddFlight';
import FlightList from '../../components/flight-detail/FlightList';
import UpdateFlight from '../../components/flight-detail/UpdateFlight';

const Flight = () => {
  let { method } = useParams();

  return (
    <>
      <PageTitleAndSnackBar pageTitle={"Flight"} />

      {method == "add" && <AddFlight />}
      {method == "update" && < UpdateFlight />}
      {method == "list" && <FlightList />}

    </>
  )
}

export default Flight